import ActiveMemberChecklist from '@/pages/Profile/components/ChecklistSection/components/ActiveMemberChecklist';
import IntakeChecklist from '@/pages/Profile/components/ChecklistSection/components/IntakeChecklist';

const ChecklistSection = () => {
  const sectionClassName = 'mb-2';

  return (
    <>
      <IntakeChecklist className={sectionClassName} />
      <ActiveMemberChecklist />
    </>
  );
};

export default ChecklistSection;
